import { UPDATE_COMPANY } from './gql/update.company';
export const updateCompanyQuery = async (gqlInstance, input, updateRule) => {
    return gqlInstance
        .getClient('graphqlClient')
        .mutate({
        mutation: UPDATE_COMPANY,
        variables: { input, updateRule },
    })
        .then((response) => response.data && response.data.updateCompany.company);
};
//# sourceMappingURL=company.mutations.js.map